import Tooltip from './Tooltip';
import TooltipLarge from './TooltipLarge';

function DisabledButtonTooltip({
	show = false,
	children,
	title,
	description,
	...props
}) {
	if (!show) {
		return children;
	}

	const buttonContent = (
		<div role="button" className="can-hover:cursor-auto">
			{children}
		</div>
	);

	if (description) {
		return (
			<TooltipLarge title={title} description={description}>
				{buttonContent}
			</TooltipLarge>
		);
	}

	return (
		<Tooltip title={title} {...props}>
			{buttonContent}
		</Tooltip>
	);
}

export default DisabledButtonTooltip;
